import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import InternetProfilesHelpModal from "./Help";
import InternetProfileSettingsHelpModal from "./SettingsHelp";
import { composedAPI } from "./api";
import internetComposition from "./composition";

const ConfigInternetProfiles = ({ ...settings }) => (
  <>
    <ProfilesAndSettings
      {...internetComposition}
      {...composedAPI}
      {...settings}
    />
    <InternetProfilesHelpModal />
    <InternetProfileSettingsHelpModal />
  </>
);

export default ConfigInternetProfiles;
